import React from "react";
import QuickLink from "./QuickLink";
import { QuickLinksContainer } from "./QuickLinkStyles";
const QuickLinks = ({ links = [], customLinkComponent }) => {
    return (React.createElement(QuickLinksContainer, null, links.map((ql) => (React.createElement(QuickLink, { ...ql, key: ql.name, customLinkComponent: customLinkComponent })))));
};
export default QuickLinks;
//# sourceMappingURL=QuickLinks.js.map